import { Button, type ButtonProps, Text } from '@grammarly/design-system'
import classNames from 'classnames'
import classes from './GetProButtonGhost.module.scss'

export type GetProButtonGhostProps = Omit<ButtonProps, 'variant' | 'size'> & {
  children: React.ReactNode
}

export const GetProButtonGhost = (props: GetProButtonGhostProps) => {
  const { children, className, ...restProps } = props

  return (
    <Button
      {...restProps}
      variant="ghost"
      size="small"
      className={classNames(classes.getProButtonGhost, className)}
    >
      <Text as="span" weight="semibold" variant="text-xsmall" className={classes.getProButtonCTA}>
        {children}
      </Text>
      <Text as="span" weight="semibold" variant="text-xsmall">
        →
      </Text>
    </Button>
  )
}
